exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".IdentifyAssigneeCard-main-3uRLg h5{overflow:hidden;margin:10px 0;text-transform:none}.IdentifyAssigneeCard-main-3uRLg h5 a{display:block;float:right;color:#00e5ce}.IdentifyAssigneeCard-visibility-3m9bR{display:none}.IdentifyAssigneeCard-visibility-3m9bR.IdentifyAssigneeCard-visible-27XwW{display:initial}", ""]);

// exports
exports.locals = {
	"main": "IdentifyAssigneeCard-main-3uRLg",
	"visibility": "IdentifyAssigneeCard-visibility-3m9bR",
	"visible": "IdentifyAssigneeCard-visible-27XwW"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/ticket/components/IdentifyAssigneeCard.less
// module id = 1761
// module chunks = 0